// Generated by Melange

import * as Buhta_landing__Link from "../../components/html/Link.js";
import * as Buhta_landing__Route from "../../Route.js";
import * as JsxRuntime from "react/jsx-runtime";

function DocsKassa(Props) {
  const language = Buhta_landing__Route.getLanguage(undefined);
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("h3", {
        children: "Касса",
        className: "h4 lg:h3 text-black-landing mt-10 lg:mt-16"
      }),
      JsxRuntime.jsx("p", {
        children: "The Buhta Dashboard offers a user interface for you to operate and configure your Buhta account. You can use it to manage payments and refunds, respond to disputes, monitor your integration, and more.",
        className: "paragraph text-black-landing mt-2 lg:mt-1"
      }),
      JsxRuntime.jsx("h6", {
        children: "Subcategory",
        className: "h6 text-black-landing mt-10"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs(Buhta_landing__Link.make, {
            route: {
              TAG: /* Docs */ 1,
              _0: /* COUNTRY_KAZ */ 1,
              _1: language,
              _2: /* Post */ 2
            },
            className: "lg:w-68 bg-bg px-4 py-3 rounded",
            children: [
              JsxRuntime.jsx("p", {
                children: "Financial reports",
                className: "paragraph-medium text-primary-variant"
              }),
              JsxRuntime.jsx("p", {
                children: "Get the data you need to complete your critical accounting and reconciliation workflows.",
                className: "paragraph-small text-gray-landing"
              })
            ]
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("p", {
                children: "Sigma",
                className: "paragraph-medium text-primary-variant"
              }),
              JsxRuntime.jsx("p", {
                children: "Use Stripe Sigma to let accounting teams view and understand payment data in the browser.",
                className: "paragraph-small text-gray-landing"
              })
            ],
            className: "lg:w-68 bg-bg px-4 py-3 rounded-sm mt-6 lg:mt-0"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("p", {
                children: "Buhta Dashboard",
                className: "paragraph-medium text-primary-variant"
              }),
              JsxRuntime.jsx("p", {
                children: "Learn how to use Dashboard features to monitor and manage your business data on Stripe.",
                className: "paragraph-small text-gray-landing"
              })
            ],
            className: "lg:w-68 bg-bg px-4 py-3 rounded-sm mt-6 lg:mt-0"
          })
        ],
        className: "flex justify-between mt-4 flex-wrap"
      }),
      JsxRuntime.jsx("h6", {
        children: "Start and grow your business",
        className: "h6 text-black-landing mt-10"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("p", {
                children: "Buhta Atlas",
                className: "paragraph-medium text-primary-variant"
              }),
              JsxRuntime.jsx("p", {
                children: "Use Stripe Atlas to incorporate your startup and issue stock to founders.",
                className: "paragraph-small text-gray-landing"
              })
            ],
            className: "lg:w-68 bg-bg px-4 py-3 rounded"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("p", {
                children: "Financial services",
                className: "paragraph-medium text-primary-variant"
              }),
              JsxRuntime.jsx("p", {
                children: "Get help with financial services, like corporate cards and loans.",
                className: "paragraph-small text-gray-landing"
              })
            ],
            className: "lg:w-68 bg-bg px-4 py-3 rounded-sm mt-6 lg:mt-0"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("p", {
                children: "Buhta Dashboard",
                className: "paragraph-medium text-primary-variant"
              }),
              JsxRuntime.jsx("p", {
                children: "Learn to manage disputes to protect your business from fines.",
                className: "paragraph-small text-gray-landing"
              })
            ],
            className: "lg:w-68 bg-bg px-4 py-3 rounded-sm mt-6 lg:mt-0"
          })
        ],
        className: "flex justify-between mt-4 flex-wrap"
      })
    ]
  });
}

const make = DocsKassa;

export {
  make,
}
/* Buhta_landing__Link Not a pure module */
